import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-strolley",
  "use": "icon-si-glyph-strolley-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-strolley\" id=\"icon-si-glyph-strolley\"><title>1093</title><defs></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(1.000000, 0.000000)\" fill=\"#434343\"><ellipse cx=\"4.438\" cy=\"14.459\" rx=\"1.438\" ry=\"1.459\" class=\"si-glyph-fill\" /><ellipse cx=\"12.457\" cy=\"14.419\" rx=\"1.457\" ry=\"1.419\" class=\"si-glyph-fill\" /><path d=\"M15,10.016 L3.953,10.016 L3.953,3.778 L1.781,0.41 C1.457,-0.034 0.836,-0.132 0.392,0.191 C-0.051,0.515 -0.149,1.138 0.174,1.584 L2.023,4.485 L2.023,10.016 L1.968,10.016 C1.415,10.016 0.968,10.456 0.968,11 C0.968,11.543 1.415,11.984 1.968,11.984 L15,11.984 C15.553,11.984 16,11.543 16,11 C16,10.456 15.553,10.016 15,10.016 L15,10.016 Z\" class=\"si-glyph-fill\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-strolley.svg
// module id = NhtX
// module chunks = 62